import { Link } from 'react-router-dom';
import { threeCourses } from '@/mocks/aboutData';
import { useTranslation } from 'react-i18next';

const courseKeys = ['essential', 'advanced', 'master'] as const;

export default function CoursesOverview() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            COURSES
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('about.courses.title')}
          </h2>
          {String(t('about.courses.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('about.courses.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {threeCourses.map((course, idx) => {
            const key = courseKeys[idx];
            return (
            <div
              key={idx}
              className={`card-glow bg-background-50 border ${
                course.recommended
                  ? 'border-accent-500/40'
                  : 'border-background-200/60'
              } p-6 flex flex-col`}
            >
              {course.recommended && (
                <div className="text-center mb-3">
                  <span className="inline-block text-[12px] tracking-[0.15em] text-accent-500 bg-accent-500/8 border border-accent-500/15 px-3 py-1 font-label">
                    RECOMMENDED
                  </span>
                </div>
              )}
              <p className="section-title-en text-accent-500 text-[14px] tracking-[0.1em] mb-2 text-center">
                {course.titleEn}
              </p>
              <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-4 text-center">
                {t(`about.courses.${key}.title`)}
              </h3>

              <div className="space-y-2 mb-5 border-t border-background-200/60 pt-4">
                <div className="flex justify-between text-[15px]">
                  <span className="text-foreground-400">{t('about.courses.periodLabel')}</span>
                  <span className="text-foreground-700">{t(`about.courses.${key}.duration`)}</span>
                </div>
                <div className="flex justify-between text-[15px]">
                  <span className="text-foreground-400">{t('about.courses.daysLabel')}</span>
                  <span className="text-foreground-700">{t(`about.courses.${key}.days`)}</span>
                </div>
                <div className="flex justify-between text-[15px]">
                  <span className="text-foreground-400">{t('about.courses.hoursLabel')}</span>
                  <span className="text-foreground-700">{t(`about.courses.${key}.hours`)}</span>
                </div>
                <div className="flex justify-between text-[15px] border-t border-background-200/60 pt-2">
                  <span className="text-foreground-400">{t('about.courses.priceLabel')}</span>
                  <span className="text-foreground-900 font-medium">
                    {course.price}{t('about.courses.currency')}<span className="text-[13px] text-foreground-400">{t('about.courses.taxNote')}</span>
                  </span>
                </div>
              </div>

              <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed mb-5 flex-1">
                {t(`about.courses.${key}.description`)}
              </p>

              <Link
                to={course.href}
                className={`inline-block w-full text-center py-3 ${
                  course.recommended
                    ? 'bg-accent-500 hover:bg-accent-400 text-primary-900 btn-glow'
                    : 'border border-accent-500/30 text-accent-600 hover:bg-accent-500/10'
                } text-[14px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap cursor-pointer`}
              >
                {t('about.courses.viewDetail')}
              </Link>
            </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/courses"
            className="text-[15px] text-accent-600 hover:text-accent-500 tracking-[0.05em] transition-colors"
          >
            {t('about.courses.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  );
}